import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Subtitle from "../../Subtitle";
import CardDemo from "../../CardDemo";
import Title from "../../Title";
import Text from "../../Text";
import Button from "../../Button";

interface TemplateProps {
  data: DataLandingPage;
}

const Template = (props: TemplateProps) => {
  const {
    bgVideo,
    subtitle,
    cards,
    headerRightText,
    headerLeftImage,
    landingTitle,
    landingText,
    backButton,
  } = props.data;

  const templateType = "landing-page-template";

  return (
    <>
      <BG bgVideo={bgVideo}>
        <Header rightText={headerRightText} leftImage={headerLeftImage} />
        <Body>
          <div style={styles.container}>
            <Subtitle
              style={{ marginTop: "49px" }}
              type={templateType}
              text={subtitle}
            />
            <div style={styles.body}>
              {(landingText || landingTitle) && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "7px",
                    }}
                  >
                    {landingTitle && (
                      <Title
                        style={{
                          fontSize: "100px",
                          fontWeight: "500",
                          lineHeight: "102px",
                        }}
                        type={templateType}
                        text={landingTitle}
                      />
                    )}
                    {landingText && (
                      <Text
                        style={{ fontSize: "28px", lineHeight: "41px" }}
                        type={templateType}
                        text={landingText}
                      />
                    )}
                  </div>
                  {backButton && <Button {...backButton} />}
                </div>
              )}
              <div style={{ display: "flex" }}>
                {cards?.map((card, index) => (
                  <div style={styles.item} key={index}>
                    <CardDemo type={`${templateType}`} {...card} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Body>
      </BG>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "-webkit-fill-available",
    flexDirection: "column" as React.CSSProperties["flexDirection"],
  },
  body: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row" as React.CSSProperties["flexDirection"],
    marginTop: "30px",
  },
  item: {
    marginRight: "40px",
  },
};

export default Template;
